import styles from './loadingScreenContent.module.scss';

export const LoadingScreenContent = () => {
  return (
    <div className={styles.wrapper}>
      <span className={styles.loader} />
    </div>
  );
};
